import { render, staticRenderFns } from "./legalPerson.vue?vue&type=template&id=692ad5d7&scoped=true&"
import script from "./legalPerson.vue?vue&type=script&lang=js&"
export * from "./legalPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692ad5d7",
  null
  
)

export default component.exports